import React from 'react';
import './InterestSelector.css';

function InterestSelector({ availableInterests, selectedInterests, onInterestToggle, loading, error, onRetry }) {
  if (loading) {
    return <div className="interest-loading">Loading interests...</div>;
  }

  if (error) {
    return (
      <div className="interest-error">
        <p>{error}</p>
        <button type="button" className="interest-retry-btn" onClick={onRetry}>Retry Loading Interests</button>
      </div>
    );
  }

  if (!availableInterests || availableInterests.length === 0) {
    return (
      <div className="interest-empty">
        <p>No interests available right now.</p>
        <button type="button" className="interest-retry-btn" onClick={onRetry}>Retry</button>
      </div>
    );
  }

  return (
    <div className="interest-selector">
      <div className="interests-grid">
        {availableInterests.map(interest => (
          <button
            key={interest}
            className={`interest-button ${selectedInterests.includes(interest) ? 'selected' : ''}`}
            onClick={() => onInterestToggle(interest)}
          >
            {interest}
          </button>
        ))}
      </div>
      {selectedInterests.length > 0 && (
        <div className="selected-interests">
          <strong>Selected Interests:</strong> {selectedInterests.join(', ')}
        </div>
      )}
    </div>
  );
}

export default InterestSelector;
